// extracted by mini-css-extract-plugin
export default {"core-values-block":"styles_core-values-block__hdDNi","core-values-block__content":"styles_core-values-block__content__v4ufm"};